/* ==========================================================================
   DUXX Energy — Custom JavaScript
   ========================================================================== */

document.addEventListener('DOMContentLoaded', () => {
  /* ---------- Scroll Fade-in Observer ---------- */
  const observerOptions = {
    root: null,
    rootMargin: '50px',
    threshold: 0.05
  };

  const observer = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        entry.target.classList.add('duxx-visible');
        entry.target.classList.add('visible');
        observer.unobserve(entry.target);
      }
    });
  }, observerOptions);

  function observeFadeIns() {
    document.querySelectorAll('.duxx-fade-in:not(.duxx-visible), .fade-in:not(.visible)').forEach(el => observer.observe(el));
  }

  observeFadeIns();

  /* ---------- Energy Particles Spawner (pauses when offscreen) ---------- */
  const heroParticleContainer = document.querySelector('[data-duxx-particles]');
  if (heroParticleContainer) {
    let particleInterval = null;

    const spawnParticle = () => {
      const particle = document.createElement('div');
      particle.classList.add('duxx-energy-particle');
      particle.textContent = 'XX';

      const size = Math.random() * 2 + 1;
      const tx = (Math.random() - 0.5) * 400;
      const ty = (Math.random() - 0.5) * 400 - 100;
      const rot = (Math.random() - 0.5) * 180;
      const duration = Math.random() * 3 + 3;

      particle.style.setProperty('--tx', `${tx}px`);
      particle.style.setProperty('--ty', `${ty}px`);
      particle.style.setProperty('--s', size);
      particle.style.setProperty('--r', `${rot}deg`);
      particle.style.setProperty('--duration', `${duration}s`);

      heroParticleContainer.appendChild(particle);

      setTimeout(() => { particle.remove(); }, duration * 1000);
    };

    const particleObserver = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting && !particleInterval) {
          particleInterval = setInterval(spawnParticle, 400);
        } else if (!entry.isIntersecting && particleInterval) {
          clearInterval(particleInterval);
          particleInterval = null;
        }
      });
    });
    particleObserver.observe(heroParticleContainer);
  }
});
